import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { APPConfig } from 'config/appConfig'
import Slider from 'rc-slider'
import './styles.scss'

@observer
class PriceFilterSlider extends React.Component {
  @observable minSelected = ''
  @observable maxSelected = ''
  @observable minLimit = ''
  @observable maxLimit = ''
  @observable isDragging = false
  constructor(props) {
    super(props)
    this.setValuesFromProps(props)
  }
  componentDidUpdate = prevProps => {
    if (JSON.stringify(prevProps.item) !== JSON.stringify(this.props.item)) {
      this.setValuesFromProps(this.props)
    }
  }
  setValuesFromProps = props => {
    const limitValues =
      props.item?.values?.find(range => range.selected == false) || ''
    const splittedLimitValues = limitValues?.name?.split?.(' ') || [0, 'to', 0]

    const alreadySelectedValues =
      props.item?.values?.find(range => range.selected == true) || ''
    const alreadySelectedRange = alreadySelectedValues?.name?.split?.(' ') || [
      0,
      'to',
      0,
    ]

    this.minLimit = parseInt(splittedLimitValues?.[0] || 0)
    this.maxLimit = parseInt(splittedLimitValues?.[2] || 0)
    const minSelectedFromUrl = parseInt(alreadySelectedRange[0] || 0)
    const maxSelectedFromUrl = parseInt(alreadySelectedRange[2] || 0)

    this.minSelected = minSelectedFromUrl || this.minLimit
    this.maxSelected = maxSelectedFromUrl || this.maxLimit
  }
  // debouncedChangedEvent = debounce(mixMaxArray => {
  //   this.props.onSliderChange(this.props.item?.key || 'range_facet_price', {
  //     name: `${mixMaxArray[0]} to ${mixMaxArray[1]}`,
  //     selected: false,
  //   })
  // }, 1000)

  getStepFromConfig = () => {
    const filterSteps = APPConfig?.getAppConfig()?.filterSteps || {}
    const diffBetweenMinAndMax = this.maxLimit - this.minLimit
    let diffArray = Object.keys(filterSteps) || []
    diffArray?.pop?.()
    let range = diffArray
      ?.sort?.((a, b) => parseInt(a) - parseInt(b))
      ?.find?.(range => {
        return parseInt(diffBetweenMinAndMax) <= parseInt(range)
      })
    return parseInt((range ? filterSteps[range] : filterSteps.beyond) || 1)
  }
  handleSliderChange = mixMaxArray => {
    this.minSelected = mixMaxArray[0]
    this.maxSelected = mixMaxArray[1]
  }
  handleAfterChange = mixMaxArray => {
    // this.debouncedChangedEvent(mixMaxArray)
    this.props.onSliderChange(this.props.item?.key || 'range_facet_price', {
      name: `${mixMaxArray[0]} to ${mixMaxArray[1]}`,
      selected: false,
    })
  }
  render() {
    const step = this.getStepFromConfig()
    return (
      <div className="price-range-slider-wrapper">
        <div className="price-text-wrapper">
          <div className="price-range-start">{`$${this.minSelected}`}</div>
          <div className="price-range-end">{`$${this.maxSelected}`}</div>
        </div>
        <div className="price-slider-wrapper">
          <Slider
            range
            min={parseInt(this.minLimit)}
            max={parseInt(this.maxLimit)}
            step={parseInt(step)}
            value={[this.minSelected, this.maxSelected]}
            className={'price-range-slider'}
            onBeforeChange={() => {
              this.isDragging = true
            }}
            onChange={mixMaxArray => {
              this.handleSliderChange(mixMaxArray)
            }}
            onAfterChange={mixMaxArray => {
              this.isDragging = false
              this.handleAfterChange(mixMaxArray)
            }}
          />
        </div>
      </div>
    )
  }
}

export { PriceFilterSlider }
export default PriceFilterSlider
